import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { SelectCentroCosto } from 'sharedComponents/select'

const CentroCostoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='CENTRO DE COSTO' htmlFor='select-centrocosto' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idCentroCosto'>
          {({ field }) => (
            <SelectCentroCosto
              {...field}
              id='select-centrocosto'
              nivel={1}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CentroCostoFormGroup)
